import { type FC } from 'react';
import cx from 'classnames';

// @ts-expect-error - PromptInstructions doesn't have TypeScript definitions
import { PromptInstructions } from 'src/components/PromptInstructions';
import { EVENT_PAGE } from 'src/lib/events';
import { type Callback } from 'src/lib/types';
// @ts-expect-error - usePreparePromptInstructionsProps doesn't have TypeScript definitions
import { usePreparePromptInstructionsProps } from 'src/services/prompts/usePreparePromptInstructionsProps';

import { PromptFooterActions } from '../../components/PromptFooterActions';
import type { WidgetAction } from '../../lib';
import { useIsEmptyPrompt } from '../../services/useIsEmptyPrompt';
import { usePromptFilesSupport } from '../../services/usePromptFilesSupport';

import styles from './styles.module.scss';
import { useHandlers } from './useHandlers';
import { useViewState } from './useViewState';

const PLACEHOLDER =
  'Describe the content you want to create or select from one of the options below.';

interface PromptFieldProps {
  className?: string;
  onWidgetAction: Callback<WidgetAction>;
}

export const PromptField: FC<PromptFieldProps> = ({ className, onWidgetAction }) => {
  const { promptText, classifyingTemplate, editorType } = useViewState();
  const isEmptyPrompt = useIsEmptyPrompt();

  const { attachedResources, hasUploadingResources, handlePromptAction, handleUploadProgress } =
    usePromptFilesSupport();
  const promptInstructionsProps = usePreparePromptInstructionsProps({
    eventPage: EVENT_PAGE.homePage,
    attachedResources,
    provideUrlResources: true,
    provideFileResources: true,
    onAction: handlePromptAction,
    onUploadProgress: handleUploadProgress,
  });

  const { handlePromptChange, handleEditorChange } = useHandlers();

  return (
    <PromptInstructions
      className={cx(styles.root, className)}
      editableClasses={{ editable: styles.editable }}
      {...promptInstructionsProps}
      placeholder={PLACEHOLDER}
      value={promptText}
      onChange={handlePromptChange}
      attachedResources={attachedResources}
      editorDisabled={classifyingTemplate}
      footerActionsSlot={
        <PromptFooterActions
          onAction={onWidgetAction}
          disabled={classifyingTemplate}
          loading={classifyingTemplate}
          allowedSubmit={!isEmptyPrompt}
          hasUploadingResources={hasUploadingResources}
          onEditorChange={handleEditorChange}
          editorType={editorType}
        />
      }
      hideActions
    />
  );
};
